import script from "./SandBoxEstimateSummaryCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SandBoxEstimateSummaryCard.vue?vue&type=script&lang=ts&setup=true"

import "./SandBoxEstimateSummaryCard.vue?vue&type=style&index=0&id=95075d9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95075d9a"]])

export default __exports__